import styled from 'styled-components'

import { baseColors } from '@fairhq/common'

export const WhiteBoxWithShadow = styled.div`
  background-color: ${baseColors.backgroundCard};
  border-radius: 4px;
  display: flex;
  overflow: hidden;
  border: 1px solid ${baseColors.borderBackground};
`
